import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { getIcon } from "@/lib/icons";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

const CATS = { all: { de: "Alle", en: "All" }, web: { de: "Web", en: "Web" }, mobile: { de: "Mobile", en: "Mobile" }, software: { de: "Software", en: "Software" } };

export default function Services() {
  const { t, lang, pickL } = useI18n();
  const [services, setServices] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);
  const list = services.filter((s) => cat === "all" || s.category === cat);
  return (
    <div>
      <Seo title={t("nav.services")} description={t("home.servicesSub")} />
      <PageHero eyebrow={t("nav.services")} title={t("home.servicesTitle")} subtitle={t("home.servicesSub")} />
      <section className="container-x py-14">
        <div className="flex flex-wrap gap-2 mb-10">
          {Object.keys(CATS).map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`svc-filter-${c}`}
              className={`rounded-full px-5 py-2 text-sm font-semibold border transition-colors ${cat === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>
              {CATS[c][lang]}
            </button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.03}>
              <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`}
                className="group surface p-7 block h-full hover:border-primary transition-colors">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary mb-5">{getIcon(s.icon, { size: 22 })}</div>
                <h3 className="font-display font-bold text-lg mb-2">{pickL(s, "name")}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{pickL(s, "short")}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="text-sm font-semibold text-primary">{t("common.from")} {s.starting_price}€</span>
                  <ArrowRight size={16} className="text-primary opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
